'use strict';

angular.module('ClinicApp').controller('ModalProviderHoursCtrl', function($scope, $modalInstance, provider, ProviderService) {
  $scope.provider = provider;

  $scope.save = function(hours) {
    return ProviderService.updateProvider(provider.id, {
      hours: hours,
    }).then(function() {
      $modalInstance.close();
    });
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };
});
